import { FaArrowRight, FaBookReader } from "react-icons/fa";
import { Link } from "react-router-dom";

const ArticleCard = ({ article, index, featured }) => {
    const articleNumber = String(index).padStart(2, "0");

    return (
        <article className={`group relative flex h-full flex-col overflow-hidden rounded-lg border bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl dark:bg-slate-800 sm:p-8 ${featured ? "border-blue-200 dark:border-blue-900 md:col-span-2 md:grid md:grid-cols-[1fr_220px] md:p-10" : "border-slate-200 dark:border-slate-700"}`}>
            <div className="flex h-full flex-col">
                <div className="mb-5 flex items-center justify-between gap-4">
                    <span className="font-mono text-sm font-semibold tracking-widest text-blue-700 dark:text-blue-300">
                        {articleNumber} <span className="text-slate-300 dark:text-slate-600">/</span> ARTICLE
                    </span>
                    {!featured && (
                        <span className="flex shrink-0 items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
                            <FaBookReader className="text-blue-600 dark:text-blue-400" aria-hidden="true" />
                            {article.reading_time_minutes} min read
                        </span>
                    )}
                </div>

                <h2 className={`mb-4 font-bold leading-tight text-slate-950 dark:text-white ${featured ? "text-3xl sm:text-4xl md:max-w-2xl" : "text-2xl"}`}>
                    {article.title}
                </h2>

                <p className={`mb-8 flex-grow leading-relaxed text-slate-600 dark:text-slate-300 ${featured ? "max-w-2xl text-base sm:text-lg" : "text-sm sm:text-base"}`}>
                    {article.description}
                </p>

                <div className="flex items-center justify-between border-t border-slate-200 pt-5 dark:border-slate-700">
                    {featured ? (
                        <span className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
                            <FaBookReader className="text-blue-600 dark:text-blue-400" aria-hidden="true" />
                            {article.reading_time_minutes} min read
                        </span>
                    ) : <span />}
                    <Link
                        to={`/blog/${article.postId}`}
                        className="inline-flex items-center gap-2 font-semibold text-blue-700 transition-colors hover:text-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600 dark:text-blue-300 dark:hover:text-blue-200 dark:focus-visible:outline-blue-300"
                    >
                        Read article
                        <FaArrowRight className="transition-transform group-hover:translate-x-1" aria-hidden="true" />
                        <span className="sr-only">: {article.title}</span>
                    </Link>
                </div>
            </div>

            {featured && (
                <div className="mt-8 flex min-h-44 flex-col justify-between rounded-md bg-gradient-to-br from-blue-700 via-blue-600 to-teal-600 p-6 text-white md:ml-8 md:mt-0 md:p-7">
                    <span className="text-xs font-bold uppercase tracking-[0.18em] text-amber-200">Featured read</span>
                    <span className="font-mono text-7xl font-bold leading-none tracking-tight text-white/90" aria-hidden="true">
                        {articleNumber}
                    </span>
                    <span className="text-sm font-medium text-blue-50">A good place to start</span>
                </div>
            )}
        </article>
    );
};

export default ArticleCard;